// @core/api/endpoints/apikey/revoke_api_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  APIKeyResponse,
  RevokeAPIKeyRequest,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Revoke API key
 * Permanently revokes an API key, immediately blocking all access. Unlike suspension, revocation cannot be reversed. Use for security incidents or key compromise.
 */
export async function RevokeAPIKey(
  key_id: string,
  data: RevokeAPIKeyRequest,
  options?: RequestOptions
): Promise<APIKeyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/api-keys/:key_id/revoke`;
  requestPath = requestPath.replace(':key_id', encodeURIComponent(key_id));
  const requestOptions = options;
  return client.post<APIKeyResponse>(requestPath, data, requestOptions);
}
